import type { SpecialistSummary, SpecialistProfile } from '@/types/domain';

export const mockSpecialists: SpecialistSummary[] = [
  {
    slug: 'anna-koval',
    first_name: 'Анна',
    avatar_url: null,
    bio_excerpt: 'Перукарка з 12-річним досвідом. Жіночі стрижки, фарбування, догляд.',
    categories: [{ slug: 'beauty', name_ua: 'Краса і догляд' }],
    city: { slug: 'lisbon', name_ua: 'Лісабон' },
    languages: ['uk', 'pt'],
    presence_status: 'online',
    score: 87,
    review_count: 14,
    overall_score: 92,
    badges: ['punctual', 'fair_price'],
    is_verified: true,
  },
  {
    slug: 'ivan-tymchenko',
    first_name: 'Іван',
    avatar_url: null,
    bio_excerpt: 'Майстер з ремонту. Сантехніка, електрика, дрібні роботи по квартирі.',
    categories: [{ slug: 'repair', name_ua: 'Ремонт і будівництво' }],
    city: { slug: 'lisbon', name_ua: 'Лісабон' },
    languages: ['uk', 'en'],
    presence_status: 'away',
    score: 76,
    review_count: 9,
    overall_score: 84,
    badges: ['reliable'],
    is_verified: false,
  },
  {
    slug: 'mariya-ivanenko',
    first_name: 'Марія',
    avatar_url: null,
    bio_excerpt: 'Юристка. AIMA, NIF, дозвіл на проживання, сімейне возз`єднання.',
    categories: [{ slug: 'legal', name_ua: 'Юридичні послуги' }],
    city: { slug: 'porto', name_ua: 'Порту' },
    languages: ['uk', 'pt', 'en'],
    presence_status: 'online',
    score: 95,
    review_count: 32,
    overall_score: 96,
    badges: ['maestro', 'verified', 'punctual'],
    is_verified: true,
  },
  {
    slug: 'olena-bondar',
    first_name: 'Олена',
    avatar_url: null,
    bio_excerpt: 'Репетиторка англійської. Школярі, дорослі, підготовка до іспитів.',
    categories: [{ slug: 'tutoring', name_ua: 'Репетитори' }],
    city: { slug: 'lisbon', name_ua: 'Лісабон' },
    languages: ['uk', 'en'],
    presence_status: 'online',
    score: 82,
    review_count: 18,
    overall_score: 89,
    badges: ['quick_responder'],
    is_verified: true,
  },
];

export function mockSpecialistProfile(slug: string): SpecialistProfile | null {
  const summary = mockSpecialists.find((s) => s.slug === slug);
  if (!summary) return null;
  return {
    ...summary,
    bio: summary.bio_excerpt,
    cancellation_range_hours: 24,
    service_radius_km: 10,
    cities: summary.city ? [summary.city] : [],
    portfolio: [],
    qna: [],
    presets: [
      {
        id: 1,
        category_slug: summary.categories[0]?.slug ?? 'other',
        title: 'Консультація',
        description: 'Перша зустріч — 30 хв.',
        price_eur: 25,
        duration_minutes: 30,
        is_active: true,
        sort_order: 0,
      },
    ],
    reviews_summary: {
      overall_score: summary.overall_score,
      review_count: summary.review_count,
      per_question: [],
      latest: [],
    },
  };
}
